import { useSyncExternalStore } from 'react';
let routeDocumentMetadataOverride;
const routeDocumentMetadataListeners = new Set();
function emitRouteDocumentMetadataChange() {
    routeDocumentMetadataListeners.forEach((listener) => listener());
}
function subscribeToRouteDocumentMetadata(listener) {
    routeDocumentMetadataListeners.add(listener);
    return () => routeDocumentMetadataListeners.delete(listener);
}
function getRouteDocumentMetadataOverride() {
    return routeDocumentMetadataOverride;
}
export function publishRouteDocumentMetadata(pathname, metadata) {
    const publication = { id: Symbol(), metadata, pathname };
    routeDocumentMetadataOverride = publication;
    emitRouteDocumentMetadataChange();
    return () => {
        if (routeDocumentMetadataOverride?.id !== publication.id)
            return;
        routeDocumentMetadataOverride = undefined;
        emitRouteDocumentMetadataChange();
    };
}
export function useRouteDocumentMetadata(pathname) {
    const override = useSyncExternalStore(subscribeToRouteDocumentMetadata, getRouteDocumentMetadataOverride, () => undefined);
    return override?.pathname === pathname ? override.metadata : undefined;
}
//# sourceMappingURL=routeDocumentMetadata.js.map